import { Injectable } from '@angular/core';
import { Parameter } from 'projects/common/src/app/classes';

@Injectable({
  providedIn: 'root'
})
export class SoundService extends Parameter<boolean> {

  constructor() {
    super();
  }
}
